/**
 * useDebouncedValue (P68.1).
 *
 * Returns ``value`` but only after it has stayed unchanged for
 * ``delayMs`` milliseconds. Used by the topnav typeahead so a
 * burst of keystrokes coalesces into one /v1/search request.
 *
 * Pure-ish: depends on React's useState + useEffect, but the
 * behaviour is deterministic given (value, delayMs) and the
 * built-in setTimeout / clearTimeout. Vitest exercises it via
 * @testing-library/react's act() + vi.useFakeTimers.
 */
import { useEffect, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
